import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Fish, Camera } from "lucide-react";
import { api, photoUrl, fmtDate } from "../lib/api";
import { KeeperBadge } from "../components/Badges";

export default function CatchLog() {
  const [catches, setCatches] = useState(null);
  useEffect(() => { api.get("/catches").then((r) => setCatches(r.data)).catch(() => setCatches([])); }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-none">Catch<br /><span className="text-[#FF4D00]">log</span></h1>
        {catches && <span className="font-display text-3xl" data-testid="catch-log-count">{catches.length}</span>}
      </div>
      {catches === null && <p className="text-zinc-500" data-testid="catch-log-loading">Loading…</p>}
      {catches?.length === 0 && (
        <div className="brut-card p-8 text-center space-y-4" data-testid="catch-log-empty">
          <Fish size={40} className="mx-auto text-[#FF4D00]" />
          <p className="text-zinc-400">No catches yet. Your first one is a scan away.</p>
          <Link to="/scan" className="brut-btn" data-testid="catch-log-scan-btn"><Camera size={18} /> Scan a catch</Link>
        </div>
      )}
      <div className="grid grid-cols-2 gap-4">
        {catches?.map((c, i) => (
          <Link key={c.id} to={`/log/${c.id}`} data-testid={`catch-card-${c.id}`}
            className="brut-card group hover:border-[#FF4D00] transition-[border-color,transform] hover:-translate-y-1 rise"
            style={{ animationDelay: `${Math.min(i, 8) * 0.04}s` }}>
            <div className="aspect-square bg-[#1E1E24] overflow-hidden border-b-2 border-[#27272A]">
              {c.photo_path ? (
                <img src={photoUrl(c.photo_path)} alt={c.species} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-zinc-600"><Fish size={40} /></div>
              )}
            </div>
            <div className="p-3 space-y-2">
              <h3 className="font-display uppercase leading-tight truncate">{c.species}</h3>
              <div className="flex items-center justify-between text-xs text-zinc-400">
                <span>{c.length_in != null ? `${c.length_in}"` : "—"}</span>
                <span>{fmtDate(c.caught_at)}</span>
              </div>
              {c.keeper_status && <KeeperBadge status={c.keeper_status} testId={`catch-card-keeper-${c.id}`} />}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
